import DocumentTypeList from './DocumentTypeList';
import DocumentTypeEdit from './DocumentTypeEdit';
import DocumentTypeCreate from './DocumentTypeCreate';
import DocumentTypeShow from './DocumentTypeShow';

export default {
    list: DocumentTypeList,
    edit: DocumentTypeEdit,
    create: DocumentTypeCreate,
    show: DocumentTypeShow,
};
